<template>
<div style="margin-top: 113px">
    <v-container>
        <v-snackbar v-model="error" color="red darken-2">
            <b>{{ errorMessage }} </b>
        </v-snackbar>
        <h1 v-if="this.entretiens && this.entretiens.length > 0">HR Entretiens pro ({{ entretiens.length }} {{plural}})</h1> 
        <h1 v-else>HR Entretiens Pro </h1> 
        <v-card>
            <v-card-title>
                <v-col class="d-flex" cols="4">
                    <v-select
                        :items="campaignsItems"
                        v-model="year"
                        @change="updateEntretienPro"
                        ></v-select>

                </v-col>
                <v-col class="d-flex" cols="5">
                    <v-text-field v-model="filter" label="Filter on first name or last name" @keyup="filterEntretiens($event)" @click="filterEntretiens($event)"></v-text-field>
                </v-col>

            </v-card-title>
            <v-card-text>
                <v-data-table 
                    :headers="headers"
                    :items="entretiens"
                    sort-by="firstName">
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                         <template v-slot:activator={on}>
                        <v-btn
                         text icon
                         v-on="on"
                         :to="'/hRManagerEntretienPro/'+item.id">
                        <v-icon
                            small
                            class="mr-2"
                        >
                            mdi-lead-pencil
                        </v-icon>
                        </v-btn>
                        </template>
                        <span>
                            Show interview                           
                        </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator={on}>
                        <v-btn 
                        text icon
                        v-on="on"
                        :to="'/entretienProWorkflow/'+item.id">
                        <v-icon
                            small
                            class="mr-2"
                        >
                            mdi-cog-counterclockwise
                        </v-icon>
                        </v-btn>
                            </template>
                            <span>
                                Change workflow step
                            </span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>

</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'

export default {
    name: 'HREntretiens',
    data() {
        return {
            plural:null,
            entretiens: [],
            error: false,
            errorMessage: '',
            filter: '',
            year: 2021,
            campaignsEntretiens:[],
            campaignsItems: [],
            filteredEntretiens: [],
            originalEntretiens: []
        }
    },
    methods: {
        puntInPlural(){
            if(this.entretiens.length<2){
            this.plural = "entretien"
            }else {
            this.plural = "entretiens"
            }
        },
        filterEntretiens: function () {
            if (!this.filter || this.filter.length == 0) {
                this.resetFilter();
            } else {
                this.resetFilter();
                this.filteredEntretiens = [];
                this.entretiens.forEach(entretien => {
                    if (entretien.user.firstName.toLowerCase().includes(this.filter.toLowerCase()) || entretien.user.lastName.toLowerCase().includes(this.filter.toLowerCase())) {
                        this.filteredEntretiens.push(entretien);
                    }
                });
                this.entretiens = this.filteredEntretiens;
                this.puntInPlural();
            }
        },
        resetFilter: function () {
            this.entretiens = this.originalEntretiens;
            this.puntInPlural();
        },
        updateEntretienPro: function() {
            fetch(process.env.VUE_APP_ROOT_API_PATH + "api/entretiensPro/hrmanager/"+this.year , {
                method: 'GET',
                credentials: 'include',
            })
            .then((response) => {
                if (response.status == "200") {
                    return response.json();
                }
            })
            .then((json) => {
                if (json) {
                    this.entretiens = json.data;

                    this.entretiens.forEach(function(entretien) {
                        var managerFirstName = entretien.user.slm!=undefined?entretien.user.slm.firstName:''
                        var managerLastName = entretien.user.slm!=undefined?entretien.user.slm.lastName:''
                        entretien.manager=  managerFirstName + ' ' + managerLastName;
                    });

                    this.originalEntretiens = this.entretiens;
                    this.puntInPlural();
                }
            });
        }

    },
    computed: {
        headers() {
            return [ 
                { text: 'First name', value: 'user.firstName'},
                { text: 'Last name', value: 'user.lastName' },
                { text: 'Status', value: 'status.label' },
                { text: 'Year', value: 'campaignEntretienPro.year' },
                { text: 'Company entry date', value: 'user.companyEntryDate' },
                { text: 'Manager', value: 'manager' },
                { text: 'Company', value: 'user.company.label' },
                { text: 'Actions', value: 'actions', sortable: false }
            ]
        },
        ...mapGetters({
        })
    },
    mounted: function () {
        fetch(process.env.VUE_APP_ROOT_API_PATH + "api/campaingsEntretienPro" , {
            method: 'GET',
            credentials: 'include',
        })
        .then((response) => {
            if (response.status == "200") {
                return response.json();
            }
        })
        .then((json) => {
            this.campaignsEntretiens = json.data;
            for (var i = 0; i < this.campaignsEntretiens.length; i++) {
                var campaignsEntretien = this.campaignsEntretiens[i];
                this.campaignsItems.push({
                    'text':campaignsEntretien.year,
                    'value': campaignsEntretien.year
                })
            }


            if (this.campaignsEntretiens.length == 1) {
                this.updateEntretienPro()
            }
        });
    }
}
</script>

<style scoped>
.margin-top {
    margin-top: 10px;
}

.no-margin {
    margin: 0 !important;
}

.card {
    height: 100vh !important;
}

.btn-action-bilan {
    min-width: 32px !important;
}
</style>
